// * in this match table I take 1 REM as 16 PX
export const BODY_DEFAULT_FONT_SIZE = 16;

export const rem = (num: number) => `${num / BODY_DEFAULT_FONT_SIZE}rem`;
